import { render, staticRenderFns } from "./ConfigTelecom.vue?vue&type=template&id=071af4f3&scoped=true"
import script from "./ConfigTelecom.vue?vue&type=script&lang=js"
export * from "./ConfigTelecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071af4f3",
  null
  
)

export default component.exports